let g_apitoken = null;

let g_doctorFullName = null;

let g_doctor = null;

let g_client = null;

let globals = {
    g_userList: [],
    g_sessionList : [],
    g_accesstoken: null,
    g_doctor: null,
    g_timers: [],
    g_doctorList: [],
    g_currentCheckIn: null,
    setApiToken: (token) => {
        //console.log(`setApiToken ${token}`);
        g_apitoken = token;
    },
    getApiToken: (token) => {
        return g_apitoken;
    },
    setDoctorFullName: (fullname) => {
        //console.log(`setDoctorFullName ${fullname}`);
        g_doctorFullName = fullname;
    },
    getDoctorFullName: () => {
        return g_doctorFullName;
    },
    setDoctorId: (doctorId) => {
        //console.log(`setDoctor ${doctorId}`);
        g_doctor = doctorId;
    },
    getDoctorId: () => {
        return g_doctor;
    },
    setStreamClient: (client) => {
        //console.log('setStreamClient', client);
        g_client = client;
    },
    getStreamClient: () => {
        return g_client;
    },
    getOrCreateModalInstance: (id) => {
        let modal = bootstrap.Modal.getInstance(`#${id}`);
        if (modal) {
            return modal;
        }
        return new bootstrap.Modal(document.getElementById(id), {});
    }
};

export default globals;

